import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ReportsB from "../pages/reports-b";

// BD-592: /reports is the new suite. A tenancy that only has the old suite (TrustLayer, for now)
// is sent on to /reports-legacy instead of seeing the "switched off" notice.
export default function ReportsEntry() {
    const { featureSwitches, featureSwitchesLoading } = useSelector((s) => s.tenancy) || {};
    if (featureSwitchesLoading && !featureSwitches) return null;
    if (featureSwitches && !featureSwitches.enableReportsB && featureSwitches.enableReporting) {
        return <Navigate to="/reports-legacy" replace />;
    }
    return <ReportsB />;
}

// Old bookmarks and links to /reports-b land on /reports.
export function RedirectReportsB() {
    const { search, hash } = useLocation();
    return <Navigate to={{ pathname: "/reports", search, hash }} replace />;
}
